import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { GeneralService } from '../services/general.service';
import Swal from 'sweetalert2';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { LoaderServiceService } from '../services/loaderService.service';
import { DatePipe } from '@angular/common';
import { environment } from 'environments/environment';
// import * as pdfMake from 'pdfmake/build/pdfmake';
// import * as pdfFonts from 'pdfmake/build/vfs_fonts';
// (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

interface Remark {
  value: any;
  date: any;
  type: string;
}

interface Day {
  day: string;
  No1: number[];
  No2: number[];
  No3: number[];
  No4: number[];
  No5: number[];
  No6: number[];
  Remark: Remark[];
}


@Component({
  selector: 'app-measurer-reports',
  templateUrl: './measurer-reports.component.html',
  styleUrls: ['./measurer-reports.component.scss']
})

export class MeasurerReportsComponent implements OnInit {
  expandedRows: { [key: string]: boolean } = {};
  tempValue: any;
  tempOperator: any;
  humValue: any;
  humOperator: any;

  // Method to toggle expansion
  toggleRow(dayNumber: string) {
    this.expandedRows[dayNumber] = !this.expandedRows[dayNumber];
  }
  AddMeasurerItemsForm: FormGroup;
  clients: any;
  clientstofilter: any;
  dataSource: any;
  searchclicked: boolean = false;
  data: object[] = [];
  ClientId: any;
  AllBranchs: any[] = [];
  MeasurerItems: any[] = [];
  MeasurerItemstofilter: any;
  MeasurerItemsBranch: any[] = [];
  selectedMonthsDates: any[] = [];
  availableDatesMonthes: Date[] = [];

  days: Day[] = [];
  NormalValue: number
  displayedColumns: string[] = [
    "Day",
    "No1",
    "No2",
    "No3",
    "No4",
    "No5",
    "No6",
    "Remark"
  ];
 
  ItemTypes: any[] = []
  MeasurerItemsId: any;
  UserInfo: any;
  month: number;
  year: number;
  branch: any;
  code: any;
  name: any;
  HintMessage: string;
  constructor(private LoaderServiceService: LoaderServiceService, private _formBuilder: FormBuilder, public GeneralService: GeneralService
    , private datePipe: DatePipe) {
   // Get client data and creation date
   var clientdata = JSON.parse(localStorage.getItem('ClientData'));
   var createdate = this.datePipe.transform(clientdata.createdDate, 'yyyy-MM-dd')!;
   
   // Get start and end dates
   const rawStartDate = new Date(createdate);
   // Set to first day of the creation month
   const startDate = new Date(rawStartDate.getFullYear(), rawStartDate.getMonth(), 1);
   const endDate = new Date(); // Current date
   
   // Initialize arrays
   this.availableDatesMonthes = [];
 
   // Add months
   let current = new Date(startDate);
   while (current <= endDate) {
     this.availableDatesMonthes.push(new Date(current));
     current.setMonth(current.getMonth() + 1);
   }

console.log('Available Months:', this.availableDatesMonthes);

    this.UserInfo = JSON.parse(localStorage.getItem('currentuser'));

    this.initForm();
    this.onBranchValueChanges()
    this.onItemTypeValueChanges()
    this.onItemValueChanges()
    this.UserInfo = JSON.parse(localStorage.getItem('currentuser'));
    this.ClientId = this.UserInfo.clientid;
  }


  initForm() {
    this.AddMeasurerItemsForm = this._formBuilder.group({
      Item: [{ value: null, disabled: true }, Validators.required],
      ItemType: [{ value: null, disabled: true }, Validators.required],
      Branch: [null, Validators.required],
      Months: [null]
    });
  }

  GetAllItemType() {
    this.GeneralService.getallItemType().subscribe(res => {
      this.ItemTypes = res;
    });
  }



  onBranchValueChanges(): void {
    this.AddMeasurerItemsForm.get('Branch')?.valueChanges.subscribe(branchValue => {
      const ItemTypeControl = this.AddMeasurerItemsForm.get('ItemType');
      if (branchValue) {
        ItemTypeControl?.enable();
      } else {
        ItemTypeControl?.disable();
      }
    });
  }

  onItemTypeValueChanges(): void {
    this.AddMeasurerItemsForm.get('ItemType')?.valueChanges.subscribe(ItemTypeValue => {
      const ItemControl = this.AddMeasurerItemsForm.get('Item');
      ItemControl.reset()
      if (ItemTypeValue) {
        this.MeasurerItemstofilter = this.MeasurerItems.filter(x => x.Branch == this.AddMeasurerItemsForm.get('Branch').value && x.ItemType == this.AddMeasurerItemsForm.get('ItemType').value)
        ItemControl?.enable();

        // if (ItemTypeValue == 1) {
        //   this.NormalValue = 5
        //   this.HintMessage = "Refrigerators temperature cannot exceed 5 °C"

        // }
        // else if (ItemTypeValue == 2) {
        //   this.NormalValue = -18
        //   this.HintMessage = "Freezers temperature cannot exceed -18 °C"

        // }
        // else if (ItemTypeValue == 3) {
        //   this.NormalValue = 100
        //   this.HintMessage = "Vegetable Sanitation Must be 100 PPM"

        // }
        // else if (ItemTypeValue == 4) {
        //   this.NormalValue = 24
        //   this.HintMessage = "Oil cannot exceed 24 %"

        // }
      } else {
        ItemControl?.disable();
      }
    });
  }
  onItemValueChanges(): void {
    this.AddMeasurerItemsForm.get('Item')?.valueChanges.subscribe(ItemValue => {
      const ValueControl = this.AddMeasurerItemsForm.get('Value');
      if (ItemValue) {
        ValueControl?.enable();
      } else {
        ValueControl?.disable();
      }
    });
  }


  GetAllBranchs() {
    this.GeneralService.getBranchByClientId(this.ClientId).then(res => {
      this.AllBranchs = res;
      console.log(this.AllBranchs)

    })
  }
  getallMeasurerItems() {
    const ClientId = this.ClientId
    this.GeneralService.getMeasurerItemsbyclientid(ClientId).then(items => {

      this.MeasurerItems = items;
      this.MeasurerItemstofilter = items
      console.log(this.MeasurerItems)
    })
  }

  get fc() {
    return this.AddMeasurerItemsForm.controls;
  }
  ngOnInit() {
    this.getallMeasurerItems();
    this.GetAllBranchs();
    this.GetAllItemType();
  }

  compareValues(currentValue: number, targetValue: number, operator: string): boolean {
    if (operator === '>') {
      return currentValue > targetValue; // القيمة يجب أن تكون أكبر من targetValue
    } else if (operator === '<') {
      return currentValue < targetValue; // القيمة يجب أن تكون أصغر من targetValue
    } else if (operator === '>=') {
      return currentValue >= targetValue; // القيمة يجب أن تكون أكبر من أو تساوي targetValue
    } else if (operator === '<=') {
      return currentValue <= targetValue; // القيمة يجب أن تكون أصغر من أو تساوي targetValue
    } else if (operator === '==') {
      return currentValue === targetValue; // القيمة يجب أن تساوي targetValue
    }
    return false; // إذا لم يكن هناك operator صالح، نعتبر القيمة غير صحيحة
  }

  Search() {
    const type = this.ItemTypes.filter(x => x.id == this.AddMeasurerItemsForm.get('ItemType')?.value);
    if (type[0].humValue == "" || null || !type[0].humValue) {
      this.tempValue = type[0].tempValue;
      this.tempOperator = type[0].tempOperator;
    }
    else {
      this.tempValue = type[0].tempValue;
      this.tempOperator = type[0].tempOperator;
      this.humValue = type[0].humValue;
      this.humOperator = type[0].humOperator;

    }



    const dateObj = new Date(this.AddMeasurerItemsForm.get("Months").value);
    const month = dateObj.getMonth() + 1; // getMonth() returns 0-based month, so add 1
    const year = dateObj.getFullYear();
    this.month = month;
    this.year = year;
    this.branch = this.AllBranchs.filter(x => x.id == this.AddMeasurerItemsForm.get("Branch").value)[0].name;
    console.log(this.MeasurerItems)
    this.code = this.MeasurerItems.filter(x => x.id == this.AddMeasurerItemsForm.get("Item").value)[0].Code;
    this.name = this.MeasurerItems.filter(x => x.id == this.AddMeasurerItemsForm.get("Item").value)[0].ItemName;

    const SearchItem = {
      clientid: this.ClientId,
      Month: month,
      Year: year,
      Branch: this.AddMeasurerItemsForm.get("Branch").value,
      Item: this.AddMeasurerItemsForm.get("Item").value,
    }

    console.log(this.generateDays(month, year));
    this.GeneralService.GetMeasurerByMonth(SearchItem).then(res => {

      if (Array.isArray(res) && res.length === 0) {
        this.searchclicked = false;
        this.GeneralService.fireEmpty();
        // Handle the empty array case here
      } else {
        this.searchclicked = true;
        this.days.forEach((element, index) => {
          const data = res.filter(x => x.Day == index + 1)
          data.sort((a, b) => {
            const dateA = new Date(a.CreationDate).getTime();
            const dateB = new Date(b.CreationDate).getTime();
            return dateA - dateB;
          });
          console.log(data)
          var filteredLenght = data.filter(element => element.alert === undefined || element.alert === null || element.alert === false).length;
          var fulllenght = filteredLenght;
          console.log(filteredLenght)
          data.forEach((element2, index2) => {
            if (element2.alert === undefined || element2.alert === null || element2.alert === false) {
              if (element2.humvalue) {
                element[`No${filteredLenght - fulllenght + 1}`] = [element2.tempvalue, element2.humvalue];
              } else {
                element[`No${filteredLenght - fulllenght + 1}`] = [element2.tempvalue];
              }
              element[`Date${filteredLenght - fulllenght + 1}`] = element2.CreationDate;
              filteredLenght = filteredLenght + 1;

            } else {
              if (element2.alerttype == "temp") {
                element[`Remark`].push({ value: element2.tempvalue, date: element2.CreationDate, type: "temp" });
              } else {
                element[`Remark`].push({ value: element2.humvalue, date: element2.CreationDate, type: "rh" });
              }
            }
          });



        });

      }





    })
    this.dataSource = new MatTableDataSource(this.days);


    console.log(this.days);
  }

  formatCellValue(values: any[]): string[] {
    if (!Array.isArray(values)) {
      return [values];
    }
    return values;
  }

  addMeasurerItems() {
    console.log(this.AddMeasurerItemsForm.value)
    if (this.AddMeasurerItemsForm.status == "VALID") {
      this.Search()
    }
    else {
      this.AddMeasurerItemsForm.markAllAsTouched();
    }
  }




  generateDays(year: number, month: number): void {
    this.days = [];
    const date = new Date(year, month - 1, 1); // Month is 0-indexed
    const daysInMonth = new Date(year, month, 0).getDate();

    for (let i = 1; i <= daysInMonth; i++) {
      const daySuffix = this.getDaySuffix(i);
      this.days.push({
        day: `${i}${daySuffix}`,
        No1: [],
        No2: [],
        No3: [],
        No4: [],
        No5: [],
        No6: [],
        Remark: []
      });
    }
    console.log(this.days)
  }
  getDaySuffix(day: number): string {
    if (day % 10 === 1 && day % 100 !== 11) {
      return 'st';
    } else if (day % 10 === 2 && day % 100 !== 12) {
      return 'nd';
    } else if (day % 10 === 3 && day % 100 !== 13) {
      return 'rd';
    } else {
      return 'th';
    }
  }



  // exportToPDF(): void {
  //   this.LoaderServiceService.show();
  //   const doc = new jsPDF();

  //   doc.setFontSize(10);
  //   doc.setFont('helvetica', 'normal');
  
  //   const headerTableData = [
  //     [
  //       this.month,
  //       this.year,
  //       this.branch,
  //       this.code,
  //       this.name
  //     ]
  //   ];

  //   // Add custom header table
  //   (doc as any).autoTable({
  //     head: [['Month', 'Year', 'Branch', 'Code', 'Name']], // Header titles
  //     body: headerTableData, // Header data
  //     // startY: headerTableStartY, // Starting Y position for the header table
  //     margin: { horizontal: 5 }, // Margins
  //     styles: {
  //       fontSize: 9,
  //       cellPadding: 1, // Padding inside each cell
  //       lineColor: [0, 0, 0], // Border color (black)
  //       lineWidth: 0.2, // Border width (thin)
  //       fontStyle: 'bold', // Make text bold
  //       halign: 'center' // Center align text horizontally
  //     },


   
  //     headStyles: {
  //       fillColor: [255, 255, 255], // Header background color (white)
  //       textColor: [0, 0, 0], // Header text color (black)
  //       fontStyle: 'bold', // Make header text bold
  //       halign: 'center' // Center align header text
  //     },
  //     theme: 'grid', // Grid theme for full borders
  //     tableLineColor: [0, 0, 0], // Table outer border color (black)
  //     tableLineWidth: 0.5 // Table outer border width
  //   });

  //   // Adjust starting Y position for the main table
  //   const headerTableHeight = (doc as any).autoTable.previous.finalY;
  //   const tableStartY = headerTableHeight + 5; // Add margin below the header table

  //   // Prepare table data

  //   const evaluateCondition = (value: number, index: number) => {
  //     var operator;
  //     console.log(index)
  //     if (index === 0) {
  //       operator = this.tempOperator;
  //     }
  //     else{
  //       operator = this.humOperator;
  //     }
       
  //     switch (operator) {
  //       case '>':
  //         if (index === 0) {
  //           return value > this.tempValue;
  //         }
  //         else {
  //           return value > this.humValue;
  //         }
  //       case '<':
  //         if (index === 0) {
  //           return value > this.tempValue;
  //         }
  //         else {
  //           return value > this.humValue;
  //         }
  //       case '>=':
  //         if (index === 0) {
  //           return value > this.tempValue;
  //         }
  //         else {
  //           return value > this.humValue;
  //         }
  //       case '<=':
  //         if (index === 0) {
  //           return value > this.tempValue;
  //         }
  //         else {
  //           return value > this.humValue;
  //         }
  //       case '==':
  //         if (index === 0) {
  //           return value > this.tempValue;
  //         }
  //         else {
  //           return value > this.humValue;
  //         }
  //       case '=':
  //         if (index === 0) {
  //           return value > this.tempValue;
  //         }
  //         else {
  //           return value > this.humValue;
  //         }
  //       case '!=':
  //         if (index === 0) {
  //           return value > this.tempValue;
  //         }
  //         else {
  //           return value > this.humValue;
  //         }
  //       case '<>':
  //         if (index === 0) {
  //           return value > this.tempValue;
  //         }
  //         else {
  //           return value > this.humValue;
  //         }
  //          default:
  //         return false;
  //     }
  //   };


    

  //   // Prepare table data
  //   // Prepare table data
  //   const tableData = this.days.map((item: any) => [
  //     // Day
  //     item.day,
  //     // No1-No6 with values and time only if values exist
  //     `${item.No1 && item.No1.length > 0 ?
  //       item.No1.map((value: any,index) => {
  //         const status = !isNaN(parseFloat(value)) && evaluateCondition(parseFloat(value),index) ? 'fail' : 'success';
  //         return `${value} - ${status}`;
  //       }).join('\n') + '\n' + this.formatTime(item.Date1) : ''}`,
  //     `${item.No2 && item.No2.length > 0 ?
  //       item.No2.map((value: any,index) => {
  //         const status = !isNaN(parseFloat(value)) && evaluateCondition(parseFloat(value),index) ? 'fail' : 'success';
  //         return `${value} - ${status}`;
  //       }).join('\n') + '\n' + this.formatTime(item.Date1) : ''}`,
  //     `${item.No3 && item.No3.length > 0 ?
  //       item.No3.map((value: any,index) => {
  //         const status = !isNaN(parseFloat(value)) && evaluateCondition(parseFloat(value),index) ? 'fail' : 'success';
  //         return `${value} - ${status}`;
  //       }).join('\n') + '\n' + this.formatTime(item.Date1) : ''}`,
  //     `${item.No4 && item.No4.length > 0 ?
  //       item.No4.map((value: any,index) => {
  //         const status = !isNaN(parseFloat(value)) && evaluateCondition(parseFloat(value),index) ? 'fail' : 'success';
  //         return `${value} - ${status}`;
  //       }).join('\n') + '\n' + this.formatTime(item.Date1) : ''}`,
  //     `${item.No5 && item.No5.length > 0 ?
  //       item.No5.map((value: any,index) => {
  //         const status = !isNaN(parseFloat(value)) && evaluateCondition(parseFloat(value),index) ? 'fail' : 'success';
  //         return `${value} - ${status}`;
  //       }).join('\n') + '\n' + this.formatTime(item.Date1) : ''}`,
  //     `${item.No6 && item.No6.length > 0 ?
  //       item.No6.map((value: any,index) => {
  //         const status = !isNaN(parseFloat(value)) && evaluateCondition(parseFloat(value),index) ? 'fail' : 'success';
  //         return `${value} - ${status}`;
  //       }).join('\n') + '\n' + this.formatTime(item.Date1) : ''}`,
  //     // Remarks
  //     `${item.Remark && item.Remark.length > 0 ?
  //       item.Remark.map((value: any) => `${value.type} ${value.value}`).join('\n') + '\n' + this.formatTime(item.Date1) : ''}`
  //   ]);
  //   // Table headers
  //   const headers = [['Day', 'No. 1', 'No. 2', 'No. 3', 'No. 4', 'No. 5', 'No. 6', "Remark"]];

  //   // Add table to PDF with conditional formatting
  //   (doc as any).autoTable({
  //     head: headers, // Table headers
  //     body: tableData, // Table data
  //     startY: tableStartY, // Starting position on the Y axis
  //     margin: { horizontal: 5 }, // Margins
  //     styles: {
  //       fontSize: 7,
  //       cellPadding: 1, // Padding inside each cell
  //       lineColor: [0, 0, 0], // Border color (black)
  //       lineWidth: 0.2, // Border width (thin)
  //       fontStyle: 'bold', // Make text bold
  //       halign: 'center' // Center align text horizontally
  //     },
  //     headStyles: {
  //       fillColor: [255, 255, 255], // Header background color (white)
  //       textColor: [0, 0, 0], // Header text color (black)
  //       fontStyle: 'bold', // Make header text bold
  //       halign: 'center' // Center align header text
  //     },
  //     theme: 'grid', // Grid theme for full borders
  //     tableLineColor: [0, 0, 0], // Table outer border color (black)
  //     tableLineWidth: 0.3, // Table outer border width
  //     //     didDrawCell: (data: any) => {
  //     //       if (data.column.index >= 1 && data.column.index <= 6) { // Apply to No.1 to No.8 columns
  //     //         // Get the cell value, ensuring it's a string before splitting
  //     //         let cellValueText = data.cell.text ? data.cell.text.toString() : "";

  //     //         const cellValue1 = parseFloat(cellValueText.split('\n')[0]);
  //     //         const cellValue2 = parseFloat(cellValueText.split('\n')[1]);
  //     //  const operator = this.tempOperator;
  //     //           let isConditionMet = false;
  //     //           let isConditionMet2 = false;
  //     //           // Dynamic operator comparison
  //     //           switch (operator) {
  //     //             case '>':
  //     //               isConditionMet = cellValue1 > this.tempValue;
  //     //               break;
  //     //             case '<':
  //     //               isConditionMet = cellValue1 < this.tempValue;
  //     //               break;
  //     //             case '>=':
  //     //               isConditionMet = cellValue1 >= this.tempValue;
  //     //               break;
  //     //             case '<=':
  //     //               isConditionMet = cellValue1 <= this.tempValue;
  //     //               break;
  //     //             case '==':
  //     //             case '=':
  //     //               isConditionMet = cellValue1 === this.tempValue;
  //     //               break;
  //     //             case '!=':
  //     //             case '<>':
  //     //               isConditionMet = cellValue1 !== this.tempValue;
  //     //               break;
  //     //             default:
  //     //               isConditionMet = false;
  //     //           }


  //     //           switch (operator) {
  //     //             case '>':
  //     //               isConditionMet2 = cellValue2 > this.humOperator;
  //     //               break;
  //     //             case '<':
  //     //               isConditionMet2 = cellValue2 < this.humOperator;
  //     //               break;
  //     //             case '>=':
  //     //               isConditionMet2 = cellValue2 >= this.humOperator;
  //     //               break;
  //     //             case '<=':
  //     //               isConditionMet2 = cellValue2 <= this.humOperator;
  //     //               break;
  //     //             case '==':
  //     //             case '=':
  //     //               isConditionMet2 = cellValue2 === this.humOperator;
  //     //               break;
  //     //             case '!=':
  //     //             case '<>':
  //     //               isConditionMet2 = cellValue2 !== this.humOperator;
  //     //               break;
  //     //             default:
  //     //               isConditionMet = false;
  //     //           }
  //     //         // Check if cellValue is a valid number (not NaN) AND not empty

  //     //       }
  //     //     }
  //   });


  //   const now = new Date();
  //   const formattedDate = now.toISOString().split('T')[0]; // Get the date part (YYYY-MM-DD)

  //   // Convert time to 12-hour format with AM/PM
  //   const hours = now.getHours();
  //   const minutes = now.getMinutes();
  //   const seconds = now.getSeconds();
  //   const ampm = hours >= 12 ? 'PM' : 'AM';
  //   const hour12 = hours % 12 || 12; // Convert hour to 12-hour format
  //   const formattedTime = `${hour12}:${minutes.toString().padStart(2, '0')} ${ampm}`; // Remove seconds
  //   const fileName = `MeasurerReport_${formattedDate}(${formattedTime}).pdf`;
  //   // Save the PDF
  //   doc.save(fileName);
  //   this.LoaderServiceService.hide();

  // }


  exportToPDF(): void {
    let imagelogo
    console.log(localStorage.getItem("ClientLogo"))
    if (localStorage.getItem("ClientLogo")) {
      imagelogo = localStorage.getItem("ClientLogo")
    }
    else {
      imagelogo = environment.logoBase64
    }

  
    
    this.LoaderServiceService.show();
    const doc = new jsPDF();
    let startY = 10; // بداية الطباعة في الـ Y

    if (imagelogo) {
      const imgWidth = 50; // عرض الصورة
      const imgHeight = 20; // ارتفاع الصورة
      const imgX = (doc.internal.pageSize.width - imgWidth) / 2; // توسيط الصورة
      const imgY = startY; // مكان الصورة في الأعلى

      doc.addImage(imagelogo, 'PNG', imgX, imgY, imgWidth, imgHeight);

      startY += imgHeight + 10; // تحريك الجدول للأسفل بعد الصورة بمسافة
  }


    
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
  
    const headerTableData = [
      [
        this.month,
        this.year,
        this.branch,
        this.code,
        this.name
      ]
    ];

    // Add custom header table
    (doc as any).autoTable({
      head: [['Month', 'Year', 'Branch', 'Code', 'Name']],
      body: headerTableData,
      margin: { horizontal: 5 },
      startY: startY, // يبدأ الجدول بعد الصورة
      styles: {
        fontSize: 9,
        cellPadding: 1,
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
        fontStyle: 'bold',
        halign: 'center'
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        halign: 'center'
      },
      theme: 'grid',
      tableLineColor: [0, 0, 0],
      tableLineWidth: 0.5
    });

    const headerTableHeight = (doc as any).autoTable.previous.finalY;
    const tableStartY = headerTableHeight + 5;

    const evaluateCondition = (value: number, index: number) => {
      var operator = index === 0 ? this.tempOperator : this.humOperator;
      const compareValue = index === 0 ? this.tempValue : this.humValue;
      
      switch (operator) {
        case '>': return value > compareValue;
        case '<': return value < compareValue;
        case '>=': return value >= compareValue;
        case '<=': return value <= compareValue;
        case '==':
        case '=': return value === compareValue;
        case '!=':
        case '<>': return value !== compareValue;
        default: return false;
      }
    };
console.log(this.days)
    // Prepare table data with explicit empty string checks
    const tableData = this.days.map((item: any, itemIndex) => [
      item.day,
      ...['No1', 'No2', 'No3', 'No4', 'No5', 'No6'].map((key, index) => {
        const values = item[key];
        const dateKey = `Date${index + 1}`; // Map Date1 to No1, Date2 to No2, etc.
        
        if (!values || values.length === 0) {
          return ' '; // Use a space instead of empty string to trigger empty cell styling
        }
        
        return values.map((value: any, valueIndex: number) => {
          const status = !isNaN(parseFloat(value)) && evaluateCondition(parseFloat(value), valueIndex) ? 'fail' : 'success';
          return `${value} - ${status}`;
        }).join('\n') + '\n' + (item[dateKey] ? this.formatTime(item[dateKey]) : '');
      }),
      item.Remark && item.Remark.length > 0
        ? item.Remark.map((value: any) => `${value.type} ${value.value}\n${this.formatTime(value.date)}`).join('\n')
        : ' ' // Use a space for empty remarks
    ]);

    const headers = [['Day', 'No. 1', 'No. 2', 'No. 3', 'No. 4', 'No. 5', 'No. 6', "Remark"]];

    // Add table to PDF with empty cell styling
    (doc as any).autoTable({
      head: headers,
      body: tableData,
      startY: tableStartY,
      margin: { horizontal: 5 },
      styles: {
        fontSize: 7,
        cellPadding: 1,
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
        fontStyle: 'bold',
        halign: 'center'
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        halign: 'center'
      },
      theme: 'grid',
      tableLineColor: [0, 0, 0],
      tableLineWidth: 0.3,
      didDrawCell: function(data: any) {
        // Check if cell is empty (contains only whitespace)
        const cellText = data.cell.text.toString().trim();
        if (cellText === '' || cellText === ' ') {
          const doc = data.doc;
          const cell = data.cell;

          // // Fill with light gray background
          // doc.setFillColor(240, 240, 240);
          // doc.rect(cell.x, cell.y, cell.width, cell.height, 'F');

          // // Draw diagonal stripes
          // const stripeSpacing = 5; // Space between stripes in points
          // const numStripes = Math.ceil((cell.width + cell.height) / stripeSpacing);
          
          // doc.setDrawColor(220, 220, 220);
          // doc.setLineWidth(0.5);

          // const cellWidth = cell.width;
          // const cellHeight = cell.height;
          
          // // رسم الخطوط القطرية داخل حدود الخلية فقط
          // for (let i = -cellHeight; i < cellWidth; i += stripeSpacing) {
          //   const x1 = Math.max(cell.x + i, cell.x); // تأكد من أن الخط يبدأ داخل الخلية
          //   const y1 = cell.y;
          //   const x2 = cell.x;
          //   const y2 = Math.min(cell.y + i + cellHeight, cell.y + cellHeight); // تأكد من أن الخط ينتهي داخل الخلية
          
          //   doc.line(x1, y1, x2, y2);
          // }

          const stripeSpacing = 5; // المسافة بين الخطوط
const cellX = cell.x;
const cellY = cell.y;
const cellWidth = cell.width;
const cellHeight = cell.height;

// ضبط لون الخطوط
doc.setDrawColor(240, 240, 240);
doc.setLineWidth(0.5);

// رسم الخطوط القطرية داخل حدود الخلية فقط
for (let i = -cellHeight; i < cellWidth; i += stripeSpacing) {
  const x1 = cellX + i;
  const y1 = cellY;
  const x2 = cellX + i + cellHeight;
  const y2 = cellY + cellHeight;

  // ضمان بقاء الخطوط داخل الخلية
  if (x1 < cellX) {
    doc.line(cellX, y1 + (cellX - x1), x2, y2);
  } else if (x2 > cellX + cellWidth) {
    doc.line(x1, y1, cellX + cellWidth, y2 - (x2 - (cellX + cellWidth)));
  } else {
    doc.line(x1, y1, x2, y2);
  }
}


          // Add "No Data" text
          doc.setTextColor(102, 102, 102);
          doc.setFont('helvetica', 'italic'); // Fixed: Using setFont instead of setFontStyle
          doc.setFontSize(6);
          
          const text = 'No Data';
          const textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;
          const textX = cell.x + (cell.width - textWidth) / 2;
          const textY = cell.y + (cell.height / 2) + 2;
          
          doc.text(text, textX, textY);
          
          // Reset styles
          doc.setFont('helvetica', 'normal'); // Fixed: Reset font style
          doc.setTextColor(0, 0, 0);
        }
      }
    });

    const now = new Date();
    const formattedDate = now.toISOString().split('T')[0];
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const hour12 = hours % 12 || 12;
    const formattedTime = `${hour12}:${minutes.toString().padStart(2, '0')} ${ampm}`;
    const fileName = `MeasurerReport_${formattedDate}(${formattedTime}).pdf`;
    
    doc.save(fileName);
    this.LoaderServiceService.hide();
}





  formatTime(date: Date): string {
    if (!date) return ''; // Handle missing date

    // Create a new Date object from the provided date
    const dateObj = new Date(date);

    // Extract hours, minutes and format them
    let hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert hours from 24-hour to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // The hour '0' should be '12'

    // Format minutes to always have two digits
    const formattedMinutes = minutes.toString().padStart(2, '0');

    // Combine hours, minutes and AM/PM into final format
    return `${hours}:${formattedMinutes} ${ampm}`;
  }
}




